<template>
  <div>
    <top-header :type="15" placeholder="热门问题" fontSize="0.32rem" @goBack="goback"/>
    <div class="list_main">
      <div id="line" class="pad_top"></div>
      <div class="search_con">
        <van-search v-model="brokerName" placeholder="请输入问题" shape="round" @search="submit" />
      </div>
      <div class="tab_con m_flex_box flex_ar">
        <span :class="current === 1 ? 'active' : ''" @click="changeType(1)">热点问题</span>
        <span :class="current === 2 ? 'active' : ''" @click="changeType(2)">功能问题</span>
      </div>
      <div class="list">
        <div class="row m_flex_box flex_vc flex_jz" v-for="item in list" :key="item.id"
          @click="detail(item.id, item.name)">
          <div class="left m_flex_box flex_vc">
            <img src="@/assets/img/wen.png" alt="" class="img" />
            <div>
              <div class="h3">{{ item.name }}</div>
            </div>
          </div>
          <img src="@/assets/img/right.png" class="arrow_all" />
        </div>
      </div>
    </div>
    <div class="btn">
      <div class="button" @click="kefu">
        <img src="@/assets/img/kefu.png" alt="">
        <span>人工客服</span>
      </div>
    </div>
  </div>
</template>
<script>
import topHeader from '@/components/header'
export default {
  data() {
    return {
      isApp: this.$route.query.isApp || false,
      current: 1,
      list: [],
      brokerName: "",
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.init()
  },
  methods: {
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    submit() {
      this.$router.push({
        path: "/consultingService_oneDetail",
        query: {
          name:this.brokerName
        }
      })
    },
    detail(id, name) {
      this.$router.push({
        path: "/consultingService_two",
        query: {
          id: id,
          type: this.current,
          title: name
        }
      });
    },
    kefu() {
      this.$router.push({
        path: "/consultingService_four",
      })
    },
    changeType(num) {
      this.current = num
      this.init()
    },
    init() {
      this.$request_xf.get("service/api/queryIssueClassification?type=" + this.current).then((res) => {
        this.list = res.result;
      }).catch(res => {
        this.$msg(res.msg);
      });
    }
  }
}
</script>
<style lang="less" scoped>
.btn {
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  .button {
    font-size: 16px;
    width: 70%;
    height: 40px;
    background-color: #2F72F5;
    border-radius: 5px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      margin-right: 0.3rem;
      height: 0.4rem;
      width: 0.4rem;
    }
  }
}

.list {
  margin: 0 0.15rem;
  padding: 0 0.15rem;

  .row {
    width: 100%;
    padding: 0.2rem 0;
    border-bottom: 1px solid #f5f5f5;

    .img {
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.15rem;
    }

    .left {
      .h3 {
        font-size: 16px;
        color: #101010;
        // font-weight: 800;
      }

      .p {
        font-size: 24px;
        color: #A0A0A0;
      }
    }

    .i {
      font-size: 26px;
      color: #A0A0A0;
    }
  }
}


.arrow_all {
  width: 0.4rem;
  height: 0.4rem
}

.list_main {
  .tab_con {
    background-color: #fff;
    padding: 0.1rem 1rem 0;
    font-size: 0.32rem;
    background-color: #fff;
    z-index: 2;

    &.fixed {
      position: fixed;
      top: 0.9rem;
      left: 0;
      right: 0;
    }

    span {
      padding: 0.18rem 0;
      position: relative;
      color: #909090;

      &.active {
        font-weight: 800;
        color: #2F72F5;

        &:after {
          content: '';
          display: block;
          background-color: #2F72F5;
          width: 0.5rem;
          height: 0.04rem;
          position: absolute;
          left: 50%;
          margin-left: -0.25rem;
          bottom: 0;
        }
      }
    }
  }
}

.search_con {
  position: fixed;
  background-color: #fff;
  left: 0;
  right: 0;
  top: 0.9rem;
  z-index: 10;
}

.pad_top {
  padding-top: 0.9rem;
}



.top_header {
  height: 70upx;
  padding: 20upx 0upx;
  width: 660upx;
  margin: 0 auto;

  &.top_sm {
    padding: 10upx;
  }

  .flex_full {
    flex: 1
  }

  .search_con {
    background-color: #F6F6F6;
    border: 1px solid #f0f0f0;
    border-radius: 70upx;
    height: 70upx;
    box-sizing: border-box;
    font-size: 26upx;
    padding: 0 30upx;
    color: #303030;

    .i {
      font-size: 36upx;
      margin-right: 20upx;
    }
  }

  .input {
    width: 100%;
    height: 70upx;
    background-color: transparent;
  }

  .search_con {
    width: 100%;
  }

  .to_map {
    font-size: 28upx;

    .img {
      margin-right: 6upx;
      width: 32upx;
      height: 32upx;
    }
  }
}
</style>